import api from "@/api/RepositoryFactory.js";
import router from "@/router";

/* eslint-disable */
const state = () => ({
    customerMytargetInfo: {},
    customerBuzzInfo: {},
    authErrors: "",
    restoreErrors: "",
    signupErrors: [],
    isAuthorized: false,
    onChangePasswordErrors: {
        old_password: "",
        new_password: "",
        confirm_password: "",
    },
});

const getters = {
    getCustomerMytargetInfo: (state) => {
        return state.customerMytargetInfo;
    },
    getCustomerBuzzInfo: (state) => {
        return state.customerBuzzInfo;
    },
    isAuthorized: (state) => {
        return state.isAuthorized;
    },
    getAuthErrors: (state) => {
        return state.authErrors;
    },
    getRestoreErrors: (state) => {
        return state.restoreErrors;
    },
    getSignUpErrors: (state) => {
        return state.signupErrors;
    },
    getOnChangePasswordErrors: (state) => {
        return state.onChangePasswordErrors;
    }
};

const actions = {
    async loginToken({ commit, dispatch }, token) {
        try {
            const response = await api.auth.loginToken(token);
            commit("SET_AUTHORIZATION", true);
            commit("SET_AUTHORIZATION_ERRORS", {});
            commit("SET_BUZZ_CUSTOMER_INFO", response.data.result.data);
            dispatch("getMytargetInfo");

        } catch (e) {
            if (e && e.response) {
                if (e.response.data && e.response.data.errors) {
                    console.log(e.response.data.errors);
                }
                commit("SET_AUTHORIZATION_ERRORS", e.response);
            } else {
                console.log(e, { ...e });
            }
            commit("SET_AUTHORIZATION", false);
        }
    },
    async login({ commit, dispatch }, loginData) {
        try {
            const response = await api.auth.login(loginData);
            commit("SET_AUTHORIZATION", true);
            commit("SET_AUTHORIZATION_ERRORS", {});
            commit("SET_BUZZ_CUSTOMER_INFO", response.data.result.data);
            dispatch("getMytargetInfo");
            this.dispatch("List/fetchSurveysList");

            router.push({ name: "List" }).catch((err) => {
                console.log(err);
            });
        } catch (e) {
            if (e && e.response) {
                if (e.response.data && e.response.data.errors) {
                    console.log(e.response.data.errors);
                }
                commit("SET_AUTHORIZATION_ERRORS", e.response);
            } else {
                console.log(e, { ...e });
            }
            commit("SET_AUTHORIZATION", false);
        }
    },
    async getBuzzInfo({ commit, dispatch }) {
        try {
            const response = await api.auth.getBuzzInfo();
            commit("SET_BUZZ_CUSTOMER_INFO", response.data.result.data);
            commit("SET_AUTHORIZATION", true);
            dispatch("getMytargetInfo");
        } catch (e) {
            console.log(e, { ...e });
            commit("SET_AUTHORIZATION", false);
            router.push({ name: "Auth" }).catch((err) => {
                console.log(err);
            });
        }
    },
    async getMytargetInfo({ commit }) {
        try {
            const response = await api.auth.getMytargetInfo();
            commit("SET_CUSTOMER_MYTARGET_INFO", response.data.result.data);
        } catch (e) {
            console.log(e, { ...e });
        }
    },

    async logout({ commit }) {
        try {
            await api.auth.logout();
            commit("SET_AUTHORIZATION", false);
            commit("SET_BUZZ_CUSTOMER_INFO", {});
            commit("SET_CUSTOMER_MYTARGET_INFO", {});
            router
                .push({ name: "Auth" })
                .then(() => router.go())
                .catch((err) => {
                    console.log(err);
                });
        } catch (e) {
            console.log(e);
        }
    },

    async restore({ commit }, email) {
        try {
            await api.auth.restorePassword(email);
            commit("SET_RESTORE_ERRORS", "");
        } catch (e) {
            if (e.response && e.response.data) {
                commit("SET_RESTORE_ERRORS", e.response.data);
            } else {
                console.log(e);
            }
        }
    },
    async signUp({ commit }, data) {
        try {
            commit("SET_SIGNUP_ERRORS", []);
            const signUpData = {
                utm: {
                    source: "direct",
                },
                ...data,
            };
            await api.auth.signUp(signUpData);
        } catch (e) {
            if (e.response && e.response.data) {
                commit("SET_SIGNUP_ERRORS", e.response.data);
            } else {
                console.log(e);
            }
        }
    },
    async authMytarget() {
        try {
            await api.auth.authMytarget();
        } catch (e) {
            console.log(e);
        }
    },
    async tokenValidate({ commit }, token, change_password_key) {
        try {
            await api.auth.validateToken(token, change_password_key);
        } catch (e) {
            console.log({...e});
        }

    },
    async tokenLogin({ commit }, token) {
        try {
            await api.auth.Token(token);
        } catch (e) {
            console.log({...e});
        }
    },
    async changePassword({ commit }, passwords) {
        try {
            await api.auth.changePassword(passwords);
        } catch (e) {
            console.log({...e});
            commit("SET_CHANGE_PASSWORD_ERRORS", e.response.data);
        }

    },
};

const mutations = {
    SET_BUZZ_CUSTOMER_INFO(state, payload) {
        state.customerBuzzInfo = payload;
    },
    SET_CUSTOMER_MYTARGET_INFO(state, payload) {
        state.customerMytargetInfo = payload;
    },
    SET_AUTHORIZATION(state, payload) {
        state.isAuthorized = payload;
    },
    SET_AUTHORIZATION_ERRORS(state, response) {
        state.authErrors = "";
        switch (response.status) {
            case 422:
                state.authErrors = "Неверный email или пароль.";
                break;
        }
    },
    SET_RESTORE_ERRORS(state, payload) {
        state.restoreErrors = "";
        if (payload.errors && Object.values(payload.errors).length > 0) {
            for (let error of Object.values(payload.errors)) {
                switch (error[0]) {
                    case "not_exists":
                        state.restoreErrors = "Данный email не существует.";
                        break;
                    case "required":
                        state.restoreErrors = "Введите email.";
                        break;
                }
            }
        }
    },
    SET_SIGNUP_ERRORS(state, payload) {
        state.signupErrors = [];
        if (payload.errors && Object.values(payload.errors).length > 0) {
            for (const [key, value] of Object.entries(payload.errors)) {
                if (key === "agree") {
                    if (value[0] === "required") {
                        state.signupErrors.push("Примите условия соглашения.");
                    }
                } else if (key === "email") {
                    if (value[0] === "required") {
                        state.signupErrors.push("Введите email.");
                    } else if (value[0] === "invalid") {
                        state.signupErrors.push("Некорректный email.");
                    } else if (value[0] === "exists") {
                        state.signupErrors.push(
                            "Данный email уже зарегистрирован.",
                        );
                    }
                }
            }
        }
    },
    SET_CHANGE_PASSWORD_ERRORS(state, payload) {
        state.onChangePasswordErrors = {
            old_password: "",
            new_password: "",
            confirm_password: "",
        };
        if (payload.errors && Object.values(payload.errors).length > 0) {
            for (const [key, value] of Object.entries(payload.errors)) {
                if (key === "old_password") {
                    if (value[0] === "incorrect_password") {
                        state.onChangePasswordErrors[key] = "Неверный пароль";
                    }
                } else if (key === "new_password") {
                    if (value[0] === "must_be_different_password") {
                        state.onChangePasswordErrors[key] = "Должен отличаться от старого";
                    }
                }
            }
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
